import {PollAdminControl} from './PollAdminControl.js';
import {PollFolderItem} from './PollFolderItem.js';
import {PollFolderModel} from './PollFolderModel.js';
import {PollModel} from './PollModel.js';
import {PollRobotTemplate} from './PollRobotTemplate.js';

export class PollFolderList extends HTMLElement {
	constructor() {
		super();
		this.model = new PollFolderModel();
		this.model.addListener(this);
		this.shadow = this.attachShadow({mode:`open`});
		let [css, _] = PollRobotTemplate(`PollFolderList-css`);
		this.shadow.appendChild(css);

		[this.el, this.$] = PollRobotTemplate(`PollFolderList`);
		this.$.add_poll.addEventListener(`click`, evt=>{
			evt.stopPropagation(); evt.preventDefault();
			this.addPoll();
		})
		this.shadow.appendChild(this.el);
	}
	addPoll() {
		// Let a new PollModel start with a default Poll with 1 question, 2 options
		let pm = PollModel.DefaultModel();
		this.model.addPoll(pm);
		this.shadow.dispatchEvent(PollAdminControl.PollEditStartEvent(pm));
	}
	url(path) {
		return (this.hasAttribute(`api-url`)?this.getAttribute(`api-url`):"") +
			path;
	}
	connectedCallback() {
		this.$.name.innerText = this.getAttribute(`folder`);
		this.model.fetchFolder(this.url(`/poll/list/${this.getAttribute(`folder`)}/js?token=${encodeURIComponent(this.getAttribute("token"))}`));
	}

	folder_poll_added(p) {
		console.log(`folder_poll_added: p=`, p);
		let f = new PollFolderItem(this.$.polls, p);
	}
	folder_poll_removed(p) {}
	folder_poll_updated(p) {}

	doError(err) {
		console.log(err);
		alert(err);
	}	
}
customElements.define(`pollrobot-folder`, PollFolderList);